import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import SamsungOrderInvoiceSearchForm from './SamsungOrderInvoiceSearchForm';
import samsungOrderActions from 'src/store/modules/samsungOrderInvoice/actions';
import { IInitialState } from 'src/store/initialState';
import { samsungOrderInvoiceFormSel } from 'src/store/modules/samsungOrderInvoice/selectors';

const mapStateToProps = (state: IInitialState) => ({
  samsungOrderInvoiceForm: samsungOrderInvoiceFormSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  handleChangeOnSamsungForm: (formValue: any) =>
    dispatch(samsungOrderActions.updateSamsungSearchForm(formValue))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(SamsungOrderInvoiceSearchForm));
